import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react"; // lucide-react icon (যদি না থাকে তাহলে npm install lucide-react করুন)

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Scroll করলে বাটন দেখানো
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Top এ স্ক্রল করা
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-8 right-8 z-50 flex h-14 w-14 items-center justify-center rounded-full 
        bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow-xl 
        transition-all duration-300 hover:scale-110 hover:shadow-2xl 
        active:scale-95 focus:outline-none focus:ring-4 focus:ring-blue-300
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"}`}
      aria-label="Scroll to top"
    >
      <ArrowUp size={28} strokeWidth={2.5} />
    </button>
  );
};

export default ScrollToTopButton;
